<template>
  <div class="emissions-page padding-left-layout padding-top-layout">
    <page-title :title="titlePage"/>
    <div class="page-header">{{ $t("list_emissions.description_page") }}</div>
    <div class="summary">
      <div class="summary-area">
        <div class="summary-area__scope">
          <div class="summary-area__scope-left" :class="isEnableScope3?'':'disabled'">
            <scope-component v-if="isEnableScope3" :scopes="leftScopeContainer" :header="header[0]"/>
            <scope-component-disabled v-else :scopes="leftScopeContainer" :header="header[0]"/>
          </div>
          <div class="arrow mobile"><img src="@/assets/images/emissions/arrow-down.svg" alt=""/></div>
          <div class="arrow desktop"><img src="@/assets/images/emissions/arrow.svg" alt=""/></div>
          <div class="summary-area__scope-middle">
            <scope-component :scopes="middleScope1Container" :isCategory="false" :header="header[1]"/>
            <scope-component :scopes="middleScope2Container" :isCategory="false" :header="header[1]"/>
          </div>
          <div class="arrow mobile"><img src="@/assets/images/emissions/arrow-down.svg" alt=""/></div>
          <div class="arrow desktop"><img src="@/assets/images/emissions/arrow.svg" alt=""/></div>
          <div class="summary-area__scope-right" :class="isEnableScope3?'':'disabled'">
            <scope-component v-if="isEnableScope3" :scopes="rightScopeContainer" :header="header[2]"/>
            <scope-component-disabled v-else :scopes="rightScopeContainer" :header="header[2]"/>
          </div>
        </div>
        <div class="summary-area__scope">
          <scope-component :isEnableScope3="isEnableScope3" :scopes="bottomScopeContainer" :header="header[3]"/>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import ScopeComponent from '@/components/emissionScope/ScopeComponent.vue';
import ScopeComponentDisabled from '@/components/emissionScope/ScopeComponentDisabled.vue';
import {getScopesAndCategories} from '@/api/emissionCalculations';
import {mapActions, mapState} from 'vuex';
import {ROUTES} from '@/router/constants';
import CommonButton from "@/components/utils/button.vue";
import PageTitle from '@/components/pageTitle/pageTitle.vue';
import {ROLE} from '@/constants/role';

export default {
  name      : 'Home',
  components: {
    ScopeComponent,
    ScopeComponentDisabled,
    CommonButton,
    PageTitle,
  },
  data() {
    return {
      breadcrum            : [
        {
          text    : this.$t("list_emissions.hyperlink_home"),
          disabled: false,
          href    : ROUTES.HOME_DASHBOARD,
        },
        {
          text    : this.$t("list_emissions.label_list_of_emissions"),
          disabled: false,
          href    : ROUTES.EMISSIONS,
        },
      ],
      duration             : '',
      durationId           : null,
      // header               : ['上流', '自社', '下流', 'その他'],
      leftScopeContainer   : {},
      middleScope1Container: {},
      middleScope2Container: {},
      rightScopeContainer  : {},
      bottomScopeContainer : {},
      windowWidth          : window.innerWidth,
      focusElement         : null,
      isEnableScope3       : false,
      totalMonthInDuration : null,
    };
  },
  mounted() {
    this.updateBreadCrumb(this.breadcrum);
    this.getScopeStatus();
    document.addEventListener('scroll', this.removeTooltip);
  },
  watch  : {
    windowWidth: {
      handler() {
        this.windowWidth = window.innerWidth;
      },
    },
  },
  methods: {
    ...mapActions('emission', ['selectDuration', 'setScopes']),
    ...mapActions('registerData', ['updateDuration', 'updateListDuration']),
    ...mapActions('commonApp', ['updateBreadCrumb']),
    redirectToCalculationTerm() {
      return this.$router.push({path: ROUTES.CALCULATION_TERM});
    },
    countTotalMonthInDuration(durationStartAt, durationEndAt) {
      return (
        durationEndAt.getMonth() -
        durationStartAt.getMonth() +
        12 * (durationEndAt.getFullYear() - durationStartAt.getFullYear())
      );
    },
    async getScopeStatus() {
      await getScopesAndCategories({contractor_id: this.$store.state.userData.contractor})
        .then((response) => {
          let isEnableScope3 = response.find((object) => {
            return object.hasOwnProperty('display_scope_3')
          })
          this.isEnableScope3 = isEnableScope3.display_scope_3
          this.updateContainer(response);
        })
        .catch(() => {
        });
    },
    updateContainer(scopes) {
      const leftScope3           = scopes[2].categories.filter((category) => category.id < 9);
      const rightScope3          = scopes[2].categories.filter((category) => category.id > 8 && category.id < 16);
      this.middleScope1Container = {
        scope     : '1',
        scope_icon: 'scope1.svg',
        categories: [
          {
            id     : '1',
            name   : scopes[0].description,
            status : scopes[0].status,
            tooltip: this.tooltipContent()[0],
            total_month_is_register_data: scopes[0].total_month,
            total_month_in_duration: this.totalMonthInDuration
          },
        ],
      };
      this.middleScope2Container = {
        scope     : '2',
        scope_icon: 'scope2.svg',
        categories: [
          {
            id     : '1',
            name   : scopes[1].description,
            status : scopes[1].status,
            tooltip: this.tooltipContent()[1],
            total_month_is_register_data: scopes[1].total_month,
            total_month_in_duration: this.totalMonthInDuration
          },
        ],
      };
      this.bottomScopeContainer  = {
        scope     : '4',
        scope_icon: '',
        categories: [
          {
            id     : scopes[2].categories[15].id,
            name   : scopes[2].categories[15].name,
            status : scopes[2].categories[15].status,
            tooltip: this.tooltipContent()[17],
            total_month_is_register_data: scopes[2].categories[15].total_month,
            total_month_in_duration: this.totalMonthInDuration
          },
          {
            id     : '1',
            name   : scopes[3].categories[0].name,
            status : scopes[3].categories[0].status,
            tooltip: this.tooltipContent()[18],
            total_month_is_register_data: scopes[3].categories[0].total_month,
            total_month_in_duration: this.totalMonthInDuration
          },
        ],
      };
      this.leftScopeContainer    = {
        scope     : '3',
        scope_icon: 'scope3.svg',
        categories: this.formatScopeData(leftScope3),
        align     : 'left',
      };
      this.rightScopeContainer   = {
        scope     : '3',
        scope_icon: 'scope3.svg',
        categories: this.formatScopeData(rightScope3),
        align     : 'right',
      };
    },
    formatScopeData(data) {
      let formatData = [];
      data.map((category) => {
        formatData.push({
          id     : category.id,
          name   : category.name,
          status : category.status,
          tooltip: this.tooltipContent()[category.id + 1],
          total_month_is_register_data: category.total_month,
          total_month_in_duration: this.totalMonthInDuration
        });
      });
      return formatData;
    },
    tooltipContent() {
      return [
        this.$t("list_menu.tooltip_scope_1"),
        this.$t("list_menu.tooltip_scope_2"),
        this.$t("list_menu.tooltip_scope_3_category_1"),
        this.$t("list_menu.tooltip_scope_3_category_2"),
        this.$t("list_menu.tooltip_scope_3_category_3"),
        this.$t("list_menu.tooltip_scope_3_category_4"),
        this.$t("list_menu.tooltip_scope_3_category_5"),
        this.$t("list_menu.tooltip_scope_3_category_6"),
        this.$t("list_menu.tooltip_scope_3_category_7"),
        this.$t("list_menu.tooltip_scope_3_category_8"),
        this.$t("list_menu.tooltip_scope_3_category_9"),
        this.$t("list_menu.tooltip_scope_3_category_10"),
        this.$t("list_menu.tooltip_scope_3_category_11"),
        this.$t("list_menu.tooltip_scope_3_category_12"),
        this.$t("list_menu.tooltip_scope_3_category_13"),
        this.$t("list_menu.tooltip_scope_3_category_14"),
        this.$t("list_menu.tooltip_scope_3_category_15"),
        this.$t("list_menu.tooltip_scope_3_category_16"),
        this.$t("list_menu.tooltip_scope_4_category_1"),
      ];
    },
    addTooltip(event) {
      this.focusElement = event.target.parentElement;
      this.focusElement.classList.add('tooltip-icon');
    },
    removeTooltip() {
      if (this.focusElement) {
        this.focusElement.classList.remove('tooltip-icon');
      }
    },
    changeTooltipImage(event, type) {
      if (type === 'mouseleave') {
        event.target.src = this.getSettingIcon('question.svg');
      } else {
        event.target.src = this.getSettingIcon('question-active.svg');
      }
    },
    getSettingIcon(image) {
      if (image) {
        return require(`@/assets/images/emissions/status/${image}`);
      }
      return '';
    },
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.removeTooltip);
  },
  computed: {
    ...mapState('userData', ['currentUser']),
    isAdminRole() {
      return this.currentUser?.user?.role_id === ROLE.ADMIN;
    },
    titlePage() {
      return this.$t("list_emissions.title_list_of_emissions");
    },
    header() {
      return [
        this.$t("list_emissions.title_upstream"),
        this.$t("list_emissions.title_company"),
        this.$t("list_emissions.title_downstream"),
        this.$t("list_emissions.title_scope_others")
      ]
    }
  },
};
</script>
<style lang="scss" scoped>
.emissions-page {
  // .duration-wrapper {
  //   .duration-status {
  //     display: flex;
  //     align-items: center;
  //     width: max-content;
  //     margin: 0 auto;
  //     margin-top: 33px;
  //     height: 56px;
  //     position: relative;

  //     .status {
  //       display: flex;

  //       div {
  //         font-weight: 400;
  //         font-size: 13px;
  //         line-height: 24px;
  //         letter-spacing: 0.05em;
  //         color: $monoBlack;
  //         margin-left: 5px;
  //         margin-right: 17px;
  //       }
  //     }
  //   }

  //   .calculation-status-wrapper {
  //     display: flex;
  //     flex-direction: row;
  //     align-items: center;
  //     justify-content: space-between;
  //     padding: 8px 8px 8px 16px;
  //     background-color: $bgLight;
  //     border-radius: 4px;
  //     .calculation-page {
  //       display: flex;
  //       flex-direction: column;
  //       align-items: flex-start;
  //       .duration-text {
  //         color: $monoBlack;
  //         font-style: normal;
  //         font-weight: 700;
  //         font-size: 11px;
  //         line-height: 18px;
  //         letter-spacing: 0.03em;

  //       }
  //       .duration-time {
  //         font-style: normal;
  //         font-weight: 700;
  //         font-size: 14px;
  //         line-height: 24px;
  //         letter-spacing: 0.03em;
  //         color: $goldMid;
  //       }
  //     }
  //   }

  //   .tooltip-icon {
  //     &:hover:before {
  //       display: flex;
  //       justify-content: left;
  //       background: $monoWhite;
  //       border-radius: 4px;
  //       color: $monoBlack;
  //       content: attr(tooltip);
  //       margin: 0 auto;
  //       font-size: 15px;
  //       padding: 10px;
  //       width: 400px;
  //       max-width: max-content;
  //       position: absolute;
  //       right: 15px;
  //       left: unset;
  //       bottom: 40px;
  //       z-index: 999;
  //     }
  //   }
  // }

  .summary-area {
    margin-top: 48px;

    .summary-area__scope {
      .arrow {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 16px 0;

        &.desktop {
          display: none;
        }
      }
    }

    &.disabled {
      display: none;
    }
  }

  .page-header {
    margin-bottom: 48px;
    color: $monoBlack;
    font-weight: 400;
    font-size: 15px;
    line-height: 28px;
    letter-spacing: 0.05em;
  }
}
.disabled {
  opacity: 0.3;
}
@media (min-width: 1131px) {
  .emissions-page {
    padding-right: 40px;

    // .duration-wrapper {
    //   display: flex;
    //   justify-content: space-between;

    //   .duration {
    //     width: 100%;


    //   }

    //   .duration-status {
    //     margin: unset;

    //     &.mobile {
    //       display: none;
    //     }
    //   }
    // }

    .summary-area {
      margin-top: 48px;

      .summary-area__scope {
        display: flex;

        .arrow {
          padding: 0 16px;

          &.mobile {
            display: none;
          }

          &.desktop {
            display: flex;
          }
        }

        .summary-area__scope-left,
        .summary-area__scope-middle,
        .summary-area__scope-right {
          width: calc((100% - 106px) / 3);
        }

        .summary-area__scope-middle,
        .summary-area__scope-right {
          background-color: $bgLight;
        }
      }
    }
  }
}

@media (max-width: 615px) {
  .emissions-page {
    // .duration-wrapper {
    //   .tooltip-icon {
    //     &:hover {
    //       &:before {
    //         width: unset;
    //       }
    //     }
    //   }
    // }
  }
}
@include desktop {
  .calculation-status-wrapper {
    width: 315.33px;
  }
}
</style>
